import React, { useEffect, useState } from "react";
import { ReactComponent as ChevronRight } from "../svg/chevronright2.svg";
import { useNavigate } from "react-router-dom";

const RegisterWaitingPresentationFirstPage = (props: any) => {

    const navigate = useNavigate();


    return (
        <div>
            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
            }}>
                <div style={{
                    height: "100%",
                    width: "80%",
                    maxWidth: "400px",
                    margin: "0 auto",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                }}>
                    <div style={{
                        width: "100%",
                        backgroundColor: "#ffe2da",
                        aspectRatio: "1/1",
                        marginBottom: "1.06rem",
                        borderRadius: "2.01713rem",
                        position: "relative",
                        cursor: "pointer",
                    }}
                    onClick={() => {
                        navigate("/registerwaitingpresentationsubmit");
                    }}
                    >
                        <div style={{
                            fontSize: "1.344rem",
                            lineHeight: "2.01713rem",
                            marginTop: "1.34rem",
                            marginLeft: "1.56rem",
                            fontWeight : 500
                        }}>
                            수능선배 샤학관<br></br>
                            설명회 신청하고 싶어요
                        </div>
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "0.75rem",
                            width: "100%",
                        }}>
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}>
                                <img src="/img/calendar3d.webp"
                                    style={{
                                        width: "45%",
                                    }}
                                />
                            </div>
                        </div>
                        <div
                            style={{
                                position: "absolute",
                                bottom: 0,
                                width: "100%",
                                height: "17%",
                                background: "rgba(0,0,0,0.04)",
                                borderRadius: "0 0 2.01713rem 2.01713rem",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize : "1.07581rem",
                            }}
                        >
                            <div style={{
                                marginRight : "0.5rem",
                                fontWeight : 500
                            }}>
                                설명회 신청하기
                            </div>
                            <div style={{
                                paddingTop : "0.08rem"
                            }}>
                                <ChevronRight />
                            </div>
                        </div>
                    </div>
                    <div style={{
                        width: "100%",
                        backgroundColor: "#fff3e0",
                        aspectRatio: "1/1",
                        marginBottom: "1.06rem",
                        borderRadius: "2.01713rem",
                        position: "relative",
                        cursor: "pointer"
                    }}
                    onClick={() => {
                        navigate("/registerwaitingpresentationsms");
                    }}
                    >
                        <div style={{
                            fontSize: "1.344rem",
                            lineHeight: "2.01713rem",
                            marginTop: "1.34rem",
                            marginLeft: "1.56rem",
                            fontWeight : 500
                        }}>
                            N수반 사전예약<br></br>
                            안내문자 받고 싶어요
                        </div>
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "0.75rem",
                            width: "100%",
                        }}>
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}>
                                <img src="/img/envelope3d.webp"
                                    style={{
                                        width: "65%",
                                    }}
                                />
                            </div>
                        </div>
                        <div
                            style={{
                                position: "absolute",
                                bottom: 0,
                                width: "100%",
                                height: "17%",
                                background: "rgba(0,0,0,0.04)",
                                borderRadius: "0 0 2.01713rem 2.01713rem",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize : "1.07581rem",
                            }}
                        >
                            <div style={{
                                marginRight : "0.5rem",
                                fontWeight : 500
                            }}>
                                안내문자 받기
                            </div>
                            <div style={{
                                paddingTop : "0.08rem"
                            }}>
                                <ChevronRight />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RegisterWaitingPresentationFirstPage;